import { render, staticRenderFns } from "./LexonSimpleRowComponent.vue?vue&type=template&id=664d5938&scoped=true"
import script from "./LexonSimpleRowComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LexonSimpleRowComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LexonSimpleRowComponent.vue?vue&type=style&index=0&id=664d5938&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d5938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664d5938')) {
      api.createRecord('664d5938', component.options)
    } else {
      api.reload('664d5938', component.options)
    }
    module.hot.accept("./LexonSimpleRowComponent.vue?vue&type=template&id=664d5938&scoped=true", function () {
      api.rerender('664d5938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonSimpleRow/LexonSimpleRowComponent.vue"
export default component.exports